import React from "react";
import { Icon } from "@iconify/react";
import qrcodeOutline from "@iconify/icons-ant-design/qrcode-outline";
import mobileOutline from "@iconify/icons-ant-design/mobile-outline";
import Gallery from "react-grid-gallery";

const changeColor = (e) => {
  e.target.style.color = "#fcbe04";
};

const restoreColor = (e) => {
  e.target.style.color = "#007bff";
};

const awardIconStyle = {
  // backgroundImage: "linear-gradient(to bottom, #e8e8e8, #fafafa 99%)",
  // borderRadius: "100%",
  // height: "600px",
  // width: "600px",
  float: "right",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const myImages = [
  {
    src: "assets/images/awards2020/vraveia-gallery-1.jpg",
    thumbnail: "assets/images/awards2020/vraveia-gallery-1.jpg",
    thumbnailWidth: 600,
    thumbnailHeight: 400,
    caption: "QR stand βραβεία 1",
  },
  {
    src: "assets/images/awards2020/vraveia-gallery-2.jpg",
    thumbnail: "assets/images/awards2020/vraveia-gallery-2.jpg",
    thumbnailWidth: 600,
    thumbnailHeight: 400,
    caption: "QR stand βραβεία 2",
  },

  {
    src: "assets/images/awards2020/vraveia-gallery-3.jpg",
    thumbnail: "assets/images/awards2020/vraveia-gallery-3.jpg",
    thumbnailWidth: 600,
    thumbnailHeight: 400,
    caption: "QR stand βραβεία 3",
  },

  {
    src: "assets/images/awards2020/vraveia-gallery-4.jpg",
    thumbnail: "assets/images/awards2020/vraveia-gallery-4.jpg",
    thumbnailWidth: 600,
    thumbnailHeight: 400,
    caption: "QR stand βραβεία 4",
  },
];

class Awardcompany extends React.Component {
  render() {
    return (
      <section id="award" className="about">
        <div className="about-decor">
          <div className="about-circle1">
            <Icon
              style={{ marginRight: -10 }}
              width={80}
              height={80}
              icon={qrcodeOutline}
            />
            {/* <img src="assets/images/team1.png" alt="team1" /> */}
          </div>
          <div className="about-circle2">
            <Icon
              style={{ marginRight: 30 }}
              width={200}
              height={200}
              icon={mobileOutline}
            />
            {/* <img src="assets/images/main-banner1.png" alt="banner1" /> */}
          </div>
        </div>
        <div className="container">
          <div className="row ">
            <div className="col-md-5">
              <div className="about-contain">
                <div>
                  <h2 className="title">
                    <span>ΒΡΑΒΕΙΑ</span>
                  </h2>
                  <p className="caption-about">
                    Η QRSTAND βραβεύτηκε στα <b>EXHIBITION MARKETING AWARDS</b>{" "}
                    για την καινοτομία της "QRSTAND app" στο τομέα των
                    Registration & Ticket Services με SILVER ανάμεσα σε
                    κορυφαίες εταιρείες του χώρου των εμπορικών εκθέσεων.
                  </p>
                  <p className="caption-about">
                    Αποκλειστικός συνεργάτης της QRSTAND είναι η{" "}
                    <a
                      href="https://progressnet.gr/"
                      target="_blank"
                      rel="noopener noreferrer"
                      onMouseOver={changeColor}
                      onMouseOut={restoreColor}
                    >
                      PROGRESS NET
                    </a>
                    , ευθύνη της οποίας ήταν η μετουσίωση της ιδέας σε
                    λογισμικό. Η εφαρμογή QRSTAND εξελίσσεται ήδη στοχεύοντας να
                    καλύψει όλες τις ανάγκες των διοργανωτών, εκθετών και
                    επισκεπτών μιας έκθεσης.
                  </p>
                </div>
                {/* Tha mpei div gia eikones edw */}
              </div>
            </div>
            <div className="col-md-7 d-medium-none">
              <div style={awardIconStyle}>
                {/* previous classname: about-right */}
                <div className="about-phone">
                  <img
                    src="assets/images/awards2020/awards_stickers 2020_silver.png"
                    className="img-fluid"
                    alt="award"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: 80, marginBottom: 80 }}>
          <div class="container">
            <div style={{ marginTop: 20, marginBottom: 50 }}>
              <center>
                <h2>Gallery</h2>
              </center>
            </div>
            <Gallery images={myImages} />
          </div>
        </div>
      </section>
    );
  }
}

export default Awardcompany;



// WEBPACK FOOTER //
// ./src/components/awardcompany.js